import React, { useCallback } from "react";
import PropTypes from "prop-types";
import EntitiesSelector, { commonPropTypes } from "./entities-selector";
import gql from "graphql-tag";

const query = `
  query Sources($offset: Int, $limit: Int, $customerId: ID, $deploymentId: ID, $status: String, $withoutDeployment: Boolean) {
    sources(offset: $offset, limit: $limit, customerId: $customerId, deploymentId: $deploymentId, status: $status, withoutDeployment: $withoutDeployment) {
      items {
        id
        description
      }
      total
    }
  }
`;

export const sourcesQuery = gql`
  ${query}
`;

const SourceSelect = ({ id = "sourceId", name = "sourceId", isInsideForm, ...props }) => {
  const handleDataFromResponse = useCallback(data => data.sources, []);
  const handleGetValue = useCallback(element => element.id, []);
  const handleGetLabel = useCallback(element => element.description, []);

  return (
    <EntitiesSelector
      isInsideForm={isInsideForm}
      id={id}
      name={name}
      queryString={query}
      onGetDataFromResponse={handleDataFromResponse}
      onGetValue={handleGetValue}
      onGetLabel={handleGetLabel}
      {...props}
    />
  );
};

SourceSelect.propTypes = {
  ...commonPropTypes,
  /**
   * Valor del texto de la opción vacía, si existe (opcional)
   */
  emptyValueText: PropTypes.string,
};

export default SourceSelect;
